import { CancellationMode } from "@/data/model/Enums";

import CancelWholeOrderPopoverForm from "@/components/order/CancelWholeOrderPopoverForm.vue";

import { trans } from "@/app/localization/Trans";
import { VueContentPopover } from "@/app/popover/VueContentPopover";

export class CancelWholeOrderPopover extends VueContentPopover {
    constructor(
        orderId: string,
        locationId: string,
        options: {
            uniqueId: string | undefined;
            onOrderCancellationSucceeded?: () => void;
            onOrderCancellationFailed?: (errorMessage: string) => void;
        }
    ) {
        super({
            title: `${trans.cancelOrderPopover.title} - ${trans.enums.cancellationMode[CancellationMode[CancellationMode.WholeOrder]]}`,
            popoverClass: "cancel-order-popover",
            flexHeight: true,
            condensed: true,
            uniqueId: options.uniqueId,
        });
        
        this.initComponent(CancelWholeOrderPopoverForm, {
            orderId: orderId,
            locationId: locationId,
            onOrderCancellationSucceeded: options.onOrderCancellationSucceeded,
            onOrderCancellationFailed: options.onOrderCancellationFailed,
        });
    }
}
